import { HttpErrorResponse } from "@angular/common/http";
import { ActivityDetailsResultDto } from "src/app/_models/ActivityDetailResultDto";

export interface CourseContentMetadataState {
  loading: boolean;
  error: HttpErrorResponse;
  activityDetailResult: ActivityDetailsResultDto;

  resourceDetails: ActivityDetailsResultDto;
  resourceDetailsLoader: boolean;
  resourceDetailsError: HttpErrorResponse;
}

export const initialCourseContentMetadataState: CourseContentMetadataState = {
  loading: false,
  error: null,
  activityDetailResult: null,

  resourceDetails: null,
  resourceDetailsLoader: false,
  resourceDetailsError: null,
}